import type { BillingPeriod, Subscription } from "../../app/services/billing"

export function getCurrentBillingPeriod(
  billingPeriods: BillingPeriod[],
): BillingPeriod {
  const currentBillingPeriod = billingPeriods.at(-1)
  if (currentBillingPeriod === undefined)
    throw new Error("There should be at least one billing period.")
  return currentBillingPeriod
}

type NonEnterprisePlan = Exclude<Subscription, { id: "platinumplus" }>

export function isNonEnterprisePlan(
  subscription: Subscription,
): subscription is NonEnterprisePlan {
  return subscription.id !== "platinumplus"
}
